"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1979],{

/***/ 5216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContactInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4337);
/* harmony import */ var _UI_Layout_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6094);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5653);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5260);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  div p {\n    font-size: 0.875rem;\n    color: #a2aaad;\n\n    span {\n      margin-right: 10px;\n\n      svg {\n        overflow: visible;\n\n        &#phone-icon {\n          transform: translateY(20%);\n        }\n\n        &#mail-icon {\n          transform: scale(1.2);\n        }\n      }\n    }\n\n    a {\n      font-size: inherit;\n      color: inherit;\n\n      &:hover {\n        color: black;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Content = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZPm)(_UI_Layout_Container__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W)(_templateObject());
function ContactInfo() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xuv, {
        as: "section",
        display: {
            _: "none",
            desktop: "block"
        },
        position: "absolute",
        top: 0,
        left: 0,
        w: "100%",
        py: 12,
        bg: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_2__/* .FlexBox */ .h, {
                spaceX: 32,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                role: "img",
                                "aria-label": "Telephone",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Phone, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "tel:+37256988255",
                                children: " +372 5698 8255"
                            }),
                            " ",
                            t("header.times")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                role: "img",
                                "aria-label": "Mail letter",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Mail, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "mailto:klienditeenindus@baltbaby.com",
                                children: "klienditeenindus@baltbaby.com"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var Phone = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14.252",
        height: "14.252",
        viewBox: "0 0 14.252 14.252",
        id: "phone-icon",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2,8.417V4.736A.736.736,0,0,1,2.736,4H6.417a.736.736,0,0,1,.736.736V7.681a.736.736,0,0,1-.736.736H4.945a5.89,5.89,0,0,0,5.89,5.89V12.834a.736.736,0,0,1,.736-.736h2.945a.736.736,0,0,1,.736.736v3.681a.736.736,0,0,1-.736.736H10.834A8.834,8.834,0,0,1,2,8.417Z",
            transform: "translate(-1.5 -3.5)",
            fill: "none",
            stroke: "#a9bcc4",
            strokeWidth: "1"
        })
    });
};
var Mail = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "11.732",
        height: "9.336",
        viewBox: "0 0 11.732 9.336",
        id: "mail-icon",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.006,5.49a.652.652,0,0,1,.652-.652H14.08a.652.652,0,0,1,.652.652V12.87a1.3,1.3,0,0,1-1.3,1.3H4.3A1.3,1.3,0,0,1,3,12.87V5.7a.657.657,0,0,1,.006-.091ZM4.3,6.939V12.87h9.125V6.939l-3.18,3.18a1.955,1.955,0,0,1-2.765,0ZM5.328,6.12H12.4L9.327,9.2a.652.652,0,0,1-.922,0Z",
            transform: "translate(-3 -4.838)",
            fill: "#a9bcc4",
            fillRule: "evenodd"
        })
    });
};


/***/ }),

/***/ 8285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LanguageSelector; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
// EXTERNAL MODULE: ./global/constants.js
var constants = __webpack_require__(827);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
;// CONCATENATED MODULE: ./hooks/cart/useCreateLocaleCart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function useCreateLocaleCart() {
    var cookies = new Cookies();
    var ref = _slicedToArray(useMutation(CREATE_NEW_CART, {
        onCompleted: function(data) {
            var cart_id = data === null || data === void 0 ? void 0 : data.createEmptyCart;
            // Set to expire in 1 day
            var expires = dayjs().add(1, "d").toDate();
            // Set as cookie
            cookies.set(CART_ID, cart_id, {
                path: "/",
                expires: expires
            });
        }
    }), 1), createCart = ref[0];
    return createCart;
};

// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/@xstyled/system/dist/system.esm.js
var system_esm = __webpack_require__(7248);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./components/UI/Icons/Header/index.js
var Header = __webpack_require__(378);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
// EXTERNAL MODULE: ./hooks/cart/useCartData.js
var useCartData = __webpack_require__(7310);
;// CONCATENATED MODULE: ./components/Header/LanguageSelector.js
function LanguageSelector_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function LanguageSelector_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function LanguageSelector_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function LanguageSelector_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LanguageSelector_slicedToArray(arr, i) {
    return LanguageSelector_arrayWithHoles(arr) || LanguageSelector_iterableToArrayLimit(arr, i) || LanguageSelector_unsupportedIterableToArray(arr, i) || LanguageSelector_nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function LanguageSelector_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LanguageSelector_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LanguageSelector_arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  transform: rotate(-180deg);\n  transition: 0.4s ease-in-out;\n  top: 7;\n\n  @media (min-width: desktop) {\n    top: 5;\n    right: 8;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 66px;\n  transition: height 0.5s ease-in-out;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        "\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 130px;\n  margin-bottom: 6rem;\n\n  &:hover {\n    span.arrow {\n      ",
        "\n    }\n  }\n\n  span.arrow {\n    position: absolute;\n    cursor: pointer;\n    top: 3;\n    right: 10;\n    transition: 0.4s ease-in-out;\n\n    @media (min-width: desktop) {\n      top: 4;\n      right: 8;\n    }\n\n    svg {\n      transform: scale(1);\n    }\n\n    ",
        "\n  }\n\n  @media (min-width: desktop) {\n    margin-left: 4rem;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      span:nth-of-type(2) {\n        order: -1;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      span:nth-of-type(3) {\n        order: -1;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  top: 0;\n  left: 0;\n  border: 2px solid ",
        ";\n  border-radius: 12px;\n  width: 130px;\n  height: 33px;\n  padding: 0 0.4rem;\n  line-height: 1.9;\n  overflow: hidden;\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  span {\n    margin-left: 0.5rem;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}













var transformArrow = (0,styled_components_esm/* css */.ivY)(_templateObject());
var transformHeight = (0,styled_components_esm/* css */.ivY)(_templateObject1());
var Wrapper = styled_components_esm/* default.div */.ZPm.div(_templateObject3(), transformArrow, function(param) {
    var open = param.open;
    return open && (0,styled_components_esm/* css */.ivY)(_templateObject2(), transformArrow);
});
var FormControl = styled_components_esm/* default.div */.ZPm.div(_templateObject7(), system_esm.th.color("teal-100"), Wrapper, transformHeight, function(param) {
    var open = param.open;
    return open && (0,styled_components_esm/* css */.ivY)(_templateObject4(), transformHeight);
}, function(param) {
    var selectedLang = param.selectedLang;
    return selectedLang === "en" && (0,styled_components_esm/* css */.ivY)(_templateObject5());
}, function(param) {
    var selectedLang = param.selectedLang;
    return selectedLang === "et" && (0,styled_components_esm/* css */.ivY)(_templateObject6());
});
var MenuItem = styled_components_esm/* default.span */.ZPm.span(_templateObject8());
function LanguageSelector() {
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var cookies = new es6/* default */.Z();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = LanguageSelector_slicedToArray((0,esm/* useAtom */.KO)(store/* localeAtom */.S$), 2), locale1 = ref1[0], setLocale = ref1[1];
    var cart = (0,useCartData/* default */.Z)();
    var changeLocale = function(locale) {
        setLocale(locale);
        /*
    if (locale === 'en') {
      createCart();
    }
    */ router.push(router.asPath, undefined, {
            locale: locale
        });
    };
    (0,react.useEffect)(function() {
        cookies.set("BALTBABY_LOCALE", router.locale, {
            path: "/"
        });
    }, [
        router.locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        onClick: function() {
            return viewportWidth < 1024 && setOpen(!open);
        },
        open: open,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "arrow",
                role: "img",
                "aria-label": "Language menu arrow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VerticalChevron */.Cx, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl, {
                open: open,
                selectedLang: router.locale,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        "aria-label": "Select language",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                return changeLocale("et");
                            },
                            children: [
                                Header/* Estonian */.J9,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("lang.estonian")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        "aria-label": "Select language",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            onClick: function() {
                                return changeLocale("en");
                            },
                            children: [
                                Header/* English */.R0,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("lang.english")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sE": function() { return /* binding */ AccountButton; },
  "WE": function() { return /* binding */ CartButton; },
  "vw": function() { return /* binding */ LogoLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./components/UI/Icons/Header/index.js
var Header = __webpack_require__(378);
;// CONCATENATED MODULE: ./components/UI/Primitives/ConditionalWrapper.js
function ConditionalWrapper(param) {
    var condition = param.condition, wrap = param.wrap, children = param.children;
    return condition ? wrap(children) : children;
};

// EXTERNAL MODULE: ./components/Header/Navbar/styles.js
var styles = __webpack_require__(4240);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/Header/Navbar/Links.js










var LogoLink = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-label": "Go to homepage",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "img",
                "aria-label": "Baltbaby logo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Logo */.TR, {})
            })
        })
    });
};
var CartButton = function(param) {
    var quantity = param.quantity, isActive = param.isActive, onClick = param.onClick;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* IconLink */.JH, {
        role: "button",
        "aria-label": "Toggle shopping cart",
        onClick: onClick,
        isActive: isActive,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "img",
                "aria-label": "Shopping cart",
                children: Header/* ShoppingCart */.yT
            }),
            t("cart.shopping_cart"),
            quantity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ProductsInCart */.lz, {
                children: quantity
            })
        ]
    });
};
var AccountButton = function(param) {
    var onClick = param.onClick, isActive = param.isActive;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var isDesktop = viewportWidth >= 1024;
    var ref = (0,esm/* useAtomValue */.Dv)(store/* authAtom */.L4), isAuth = ref.token;
    var customer = (0,esm/* useAtomValue */.Dv)(store/* customerAtom */.TM);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* IconLink */.JH, {
        role: "button",
        "aria-label": "Toggle account menu",
        onClick: onClick,
        isActive: isActive || isAuth,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                role: "img",
                "aria-label": "Avatar",
                children: Header/* Avatar */.qE
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper, {
                condition: isDesktop,
                wrap: function(children) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                        as: "span",
                        position: "relative",
                        bottom: "0.4",
                        children: children
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                    as: "span",
                    children: isAuth ? customer ? customer.firstname : ". . ." : t("auth.login")
                })
            })
        ]
    });
};


/***/ }),

/***/ 8173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(1131);
// EXTERNAL MODULE: ./global/store.js
var store = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
;// CONCATENATED MODULE: ./hooks/UI/useHover.js

function useHover() {
    var ref = (0,react.useState)(false), isHovered = ref[0], setHovered = ref[1];
    var bind = (0,react.useMemo)(function() {
        return {
            onMouseEnter: function() {
                return setHovered(true);
            },
            onMouseLeave: function() {
                return setHovered(false);
            }
        };
    }, []);
    return [
        isHovered,
        bind
    ];
};

// EXTERNAL MODULE: ./hooks/UI/useClickOutside.js
var useClickOutside = __webpack_require__(5167);
// EXTERNAL MODULE: ./hooks/cart/useCartData.js
var useCartData = __webpack_require__(7310);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-device-detect/main.js
var main = __webpack_require__(9359);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1096);
// EXTERNAL MODULE: ./utils/getFormattedPrice.js
var getFormattedPrice = __webpack_require__(2425);
// EXTERNAL MODULE: ./hooks/UI/useLockBodyScroll.js
var useLockBodyScroll = __webpack_require__(2291);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
;// CONCATENATED MODULE: ./lib/Google/events/removeFromCart.gtag.js
function removeFromCartEvent(product) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var price = product === null || product === void 0 ? void 0 : (ref = product.price_range) === null || ref === void 0 ? void 0 : ref.maximum_price;
    return gtag("event", "remove_from_cart", {
        currency: "EUR",
        value: price === null || price === void 0 ? void 0 : (ref1 = price.final_price) === null || ref1 === void 0 ? void 0 : ref1.value,
        items: [
            {
                currency: "EUR",
                quantity: 1,
                item_name: product === null || product === void 0 ? void 0 : product.name,
                item_category: (ref2 = product === null || product === void 0 ? void 0 : product.categories[0]) === null || ref2 === void 0 ? void 0 : ref2.name,
                item_category2: (ref3 = product === null || product === void 0 ? void 0 : product.categories[1]) === null || ref3 === void 0 ? void 0 : ref3.name,
                item_category3: (ref4 = product === null || product === void 0 ? void 0 : product.categories[2]) === null || ref4 === void 0 ? void 0 : ref4.name,
                price: price === null || price === void 0 ? void 0 : (ref5 = price.final_price) === null || ref5 === void 0 ? void 0 : ref5.value,
                discount: price === null || price === void 0 ? void 0 : (ref6 = price.discount) === null || ref6 === void 0 ? void 0 : ref6.amount_off
            }
        ]
    });
};

;// CONCATENATED MODULE: ./hooks/cart/useCart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






function useCart() {
    var ref = _slicedToArray((0,esm/* useAtom */.KO)(store/* cartAtom */.cY), 2), cart = ref[0], setCart = ref[1];
    var ref1 = _slicedToArray((0,esm/* useAtom */.KO)(store/* cartSidebarAtom */.zj), 2), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(null), updatedItem = ref2[0], setUpdatedItem = ref2[1];
    var ref3 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* UPDATE_CART_ITEM */.FR, {
        variables: {
            cartId: cart === null || cart === void 0 ? void 0 : cart.id,
            uid: updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.uid,
            quantity: updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.quantity
        }
    }), 2), updateCartItem = ref3[0], data = ref3[1].data;
    var updateItem = function(item, quantity) {
        setUpdatedItem(_objectSpread({}, item, {
            quantity: quantity
        }));
    };
    (0,react.useEffect)(function() {
        if (updatedItem) {
            updateCartItem();
            if (updatedItem && updatedItem.quantity === 0) {
                removeFromCartEvent(updatedItem === null || updatedItem === void 0 ? void 0 : updatedItem.product);
            }
            (data === null || data === void 0 ? void 0 : data.cart) && setCart(data === null || data === void 0 ? void 0 : data.cart);
        }
    }, [
        updatedItem,
        data === null || data === void 0 ? void 0 : data.cart
    ]);
    return {
        cart: cart,
        open: open,
        setOpen: setOpen,
        updateItem: updateItem
    };
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var minimal_esm = __webpack_require__(9666);
// EXTERNAL MODULE: ./utils/getCartProductData.js + 1 modules
var getCartProductData = __webpack_require__(7496);
// EXTERNAL MODULE: ./utils/getProductImage.js
var getProductImage = __webpack_require__(7883);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./components/UI/Button/index.js
var Button = __webpack_require__(8356);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./components/UI/utils.js
var utils = __webpack_require__(1040);
;// CONCATENATED MODULE: ./components/Cart/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  right: ",
        ";\n  top: 0;\n  width: 400px;\n  height: 100%;\n  min-height: 100vh;\n  padding: 3rem 2rem 5rem;\n  z-index: 11;\n  overflow-y: auto;\n  background-color: white;\n  transition: right 0.75s;\n\n  /* Firefox */\n  scrollbar-width: none;\n\n  /* Chrome */\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  svg {\n    cursor: pointer;\n\n    &:hover #arrowThin {\n      stroke: black;\n    }\n  }\n\n  @media (max-width: desktop) {\n    /* top: 88px; */\n    width: 100%;\n    right: ",
        ";\n    padding: 0 1rem 10rem 1rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 43vh;\n  margin-bottom: 1rem;\n  margin-right: -1rem;\n  overflow-y: auto;\n\n  @media (max-width: desktop) {\n    height: 35vh;\n    margin-bottom: 0;\n  }\n\n  /* Firefox */\n  scrollbar-width: thin;\n  scrollbar-color: #f0f0f0 #fff;\n\n  /* Chrome */\n  ::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: #fff;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #f0f0f0;\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  padding-bottom: 4rem;\n\n  span svg {\n    margin-top: -0.2rem;\n    margin-left: 0.25rem;\n    transform: scale(0.8);\n\n    @media (max-width: desktop) {\n      transform: scale(0.9);\n    }\n  }\n\n  @media (max-width: desktop) {\n    padding-bottom: 2rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n\n  p {\n    width: 160px;\n    line-height: 1.25;\n    font-weight: 700;\n  }\n\n  .price {\n    margin: 0.5rem 0;\n    color: teal-200;\n    font-size: small;\n    font-weight: 500;\n  }\n\n  .originalPrice {\n    position: relative;\n    color: blue-200;\n    font-weight: 500;\n\n    &:after {\n      ",
        "\n    }\n  }\n\n  .variant {\n    font-size: xxsmall;\n    color: #9f9f9f;\n  }\n\n  button {\n    position: relative;\n    font-weight: 500;\n\n    span {\n      padding: 0 12px;\n    }\n\n    #minus,\n    #plus {\n      position: absolute;\n    }\n\n    #minus {\n      left: 0;\n    }\n\n    #plus {\n      right: 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 1rem;\n\n  dl {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    dt {\n      font-weight: 500;\n    }\n\n    dd {\n      font-weight: 700;\n\n      &.cartTotal {\n        font-size: medium;\n      }\n\n      &.untilFreeDelivery {\n        color: teal-400;\n      }\n\n      svg {\n        transform: scale(1.5);\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var CartContainer = styled_components_esm/* default.aside */.ZPm.aside(_templateObject(), function(param) {
    var open = param.open;
    return open ? "0" : "-400px";
}, function(param) {
    var open = param.open;
    return open ? "0" : "-100%";
});
var ProductSection = styled_components_esm/* default.section */.ZPm.section(_templateObject1());
var CartProduct = styled_components_esm/* default.divBox */.ZPm.divBox(_templateObject2());
var CartProductInfo = styled_components_esm/* default.div */.ZPm.div(_templateObject3(), utils/* CrossOut */.B4);
var PriceInfo = styled_components_esm/* default.div */.ZPm.div(_templateObject4());

// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(5885);
// EXTERNAL MODULE: ./global/constants.js
var constants = __webpack_require__(827);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3359);
// EXTERNAL MODULE: ./graphql/queries/index.js + 28 modules
var queries = __webpack_require__(4462);
;// CONCATENATED MODULE: ./components/Cart/Products.js
function Products_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Products_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Products_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Products_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Products_slicedToArray(arr, i) {
    return Products_arrayWithHoles(arr) || Products_iterableToArrayLimit(arr, i) || Products_unsupportedIterableToArray(arr, i) || Products_nonIterableRest();
}
function Products_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Products_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Products_arrayLikeToArray(o, minLen);
}
















function Products(param) {
    var propCart = param.cart, updateItem = param.updateItem;
    var ref13;
    var mainTeal = (0,styled_components_esm/* useColor */.rdp)("teal-100");
    var ref1 = (0,react.useState)(propCart), cart = ref1[0], setCart = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var cookies = new es6/* default */.Z();
    var cartId = cookies.get(constants/* CART_ID */.je);
    // Direct cart query for emergencies
    var ref3 = Products_slicedToArray((0,useLazyQuery/* useLazyQuery */.t)(queries/* CART */.$L, {
        variables: {
            id: cartId
        },
        fetchPolicy: "network-only",
        onCompleted: function(data) {
            if (data === null || data === void 0 ? void 0 : data.cart) {
                setCart(data.cart);
            }
            setIsLoading(false);
        },
        onError: function(error) {
            (0,minimal_esm/* captureException */.Tb)(error, {
                extra: {
                    action: "Products emergency cart fetch",
                    cartId: cartId
                }
            });
            setIsLoading(false);
        }
    }), 2), getCart = ref3[0], ref4 = ref3[1], cartLoading = ref4.loading, cartError = ref4.error;
    // Emergency direct refresh
    var emergencyRefresh = function() {
        if (cartId) {
            setIsLoading(true);
            getCart();
        }
    };
    // Update local cart when prop changes
    (0,react.useEffect)(function() {
        if (propCart) {
            setCart(propCart);
        }
    }, [
        propCart
    ]);
    // Handle case when cart is null but ID exists
    (0,react.useEffect)(function() {
        if (!cart && cartId && !isLoading) {
            // Try immediate emergency refresh
            emergencyRefresh();
        }
    }, [
        cart,
        cartId,
        isLoading
    ]);
    if (isLoading || cartLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSection, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Loading cart..."
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSection, {
        children: (cart === null || cart === void 0 ? void 0 : (ref13 = cart.items) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 ? cart.items.map(function(cartItem) {
            try {
                var ref, ref5, ref6, ref7;
                if (!cartItem || !cartItem.product) {
                    console.warn("Invalid cart item encountered:", cartItem);
                    return null;
                }
                var ref8 = (0,getCartProductData/* default */.Z)(cartItem), price = ref8.price, selectedVariants = ref8.selectedVariants;
                var ref9 = cartItem === null || cartItem === void 0 ? void 0 : cartItem.product, name = ref9.name, price_range = ref9.price_range, mainImage = ref9.image, media_gallery = ref9.media_gallery, uid = ref9.uid, sku = ref9.sku;
                // Get product image
                var variableUid;
                var image = (0,getProductImage/* default */.Z)({
                    mainImage: mainImage,
                    gallery: media_gallery
                }) || {
                    url: "https://do.baltbaby.com/media/logo/default/Asset_1_4x.png",
                    label: "Product Image"
                };
                if (cartItem === null || cartItem === void 0 ? void 0 : cartItem.configured_variant) {
                    var ref10, ref11;
                    variableUid = cartItem === null || cartItem === void 0 ? void 0 : (ref10 = cartItem.configured_variant) === null || ref10 === void 0 ? void 0 : ref10.uid;
                    if (cartItem === null || cartItem === void 0 ? void 0 : (ref11 = cartItem.configured_variant) === null || ref11 === void 0 ? void 0 : ref11.image) {
                        var ref12;
                        image = cartItem === null || cartItem === void 0 ? void 0 : (ref12 = cartItem.configured_variant) === null || ref12 === void 0 ? void 0 : ref12.image;
                    }
                }
                // Get original price in case of discount
                var originalPrice = (price_range === null || price_range === void 0 ? void 0 : (ref = price_range.minimum_price) === null || ref === void 0 ? void 0 : (ref5 = ref.discount) === null || ref5 === void 0 ? void 0 : ref5.percent_off) > 0 && (0,getFormattedPrice/* default */.Z)(price_range === null || price_range === void 0 ? void 0 : (ref6 = price_range.minimum_price) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.regular_price) === null || ref7 === void 0 ? void 0 : ref7.value);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartProduct, {
                    spaceX: "1rem",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image === null || image === void 0 ? void 0 : image.url,
                            alt: (image === null || image === void 0 ? void 0 : image.label) || "Product Image",
                            width: 90,
                            height: 90,
                            onError: function(e) {
                                e.currentTarget.src = "https://do.baltbaby.com/media/logo/default/Asset_1_4x.png"; // Fallback on error
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartProductInfo, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: name || "Product name not available"
                                }),
                                selectedVariants && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "variant",
                                    children: selectedVariants.join(" - ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                    align: "center",
                                    spaceX: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "price",
                                            children: price || "Price not available"
                                        }),
                                        originalPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "originalPrice",
                                            children: originalPrice
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                    p: "0.25rem",
                                    w: "100px",
                                    border: "1px solid ".concat(mainTeal),
                                    borderRadius: "18px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "button",
                                            "aria-label": "Increment product amount",
                                            id: "plus",
                                            onClick: function() {
                                                return updateItem(cartItem, cartItem.quantity + 1);
                                            },
                                            children: "+"
                                        }),
                                        cartItem.quantity,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            role: "button",
                                            "aria-label": "Decrement product amount",
                                            id: "minus",
                                            onClick: function() {
                                                return updateItem(cartItem, cartItem.quantity - 1);
                                            },
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            "aria-label": "Remove item from cart",
                            onClick: function() {
                                return updateItem(cartItem, 0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Close */.x8, {})
                        })
                    ]
                }, variableUid ? variableUid : uid);
            } catch (error) {
                (0,minimal_esm/* captureException */.Tb)(error, {
                    extra: {
                        cartItemData: cartItem,
                        errorLocation: "Cart item render"
                    }
                });
                return null; // Skip rendering this item if there's an error
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "No products in cart."
                }),
                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: emergencyRefresh,
                    p: "0.5rem 1rem",
                    border: "1px solid ".concat(mainTeal),
                    borderRadius: "18px",
                    mt: "1rem",
                    children: "Refresh Cart"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/Header/Navbar/Links.js + 1 modules
var Links = __webpack_require__(335);
// EXTERNAL MODULE: ./components/UI/Dismiss/index.js
var Dismiss = __webpack_require__(5510);
// EXTERNAL MODULE: ./components/UI/CouponCode/index.js + 1 modules
var CouponCode = __webpack_require__(2519);
// EXTERNAL MODULE: ./components/UI/Button/Variants/Primary.js
var Primary = __webpack_require__(6803);
// EXTERNAL MODULE: ./components/UI/Button/Variants/Monochrome.js
var Monochrome = __webpack_require__(7013);
// EXTERNAL MODULE: ./components/UI/Primitives/Headings.js
var Headings = __webpack_require__(7133);
// EXTERNAL MODULE: ./components/UI/Primitives/Spacer.js
var Spacer = __webpack_require__(9647);
;// CONCATENATED MODULE: ./components/UI/Icons/Cart/index.js

var EmptyCart = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "175.427",
    height: "91.067",
    viewBox: "0 0 175.427 91.067",
    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
        id: "Group_1347",
        "data-name": "Group 1347",
        transform: "translate(-97.573 -358.933)",
        fill: "#52c1d3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_242",
                "data-name": "Group 242",
                transform: "translate(97.573 358.933)",
                opacity: "0.12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2",
                        "data-name": "Path 2",
                        d: "M84.833,74.579H41.841a13,13,0,0,1-12.813-11.11l-6.07-38.155a6.631,6.631,0,0,0-6.531-5.71,3.177,3.177,0,0,1,0-6.354A13,13,0,0,1,29.24,24.364l6.07,38.155a6.631,6.631,0,0,0,6.531,5.705H84.833a6.543,6.543,0,0,0,6.434-5.155l5.214-19.133a2.611,2.611,0,0,0-.563-2.139A2.7,2.7,0,0,0,93.8,40.782H50.312a3.177,3.177,0,0,1,0-6.354H93.8a9.066,9.066,0,0,1,8.848,11.034L97.434,64.591A12.82,12.82,0,0,1,84.833,74.579Z",
                        transform: "translate(-13.25 -13.25)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3",
                        "data-name": "Path 3",
                        d: "M29.9,52.546A11.648,11.648,0,1,1,41.546,40.9,11.658,11.658,0,0,1,29.9,52.546Zm0-16.943A5.295,5.295,0,1,0,35.193,40.9,5.3,5.3,0,0,0,29.9,35.6Z",
                        transform: "translate(2.929 38.521)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_4",
                        "data-name": "Path 4",
                        d: "M37.9,52.546A11.648,11.648,0,1,1,49.546,40.9,11.658,11.658,0,0,1,37.9,52.546Zm0-16.943A5.295,5.295,0,1,0,43.193,40.9,5.3,5.3,0,0,0,37.9,35.6Z",
                        transform: "translate(28.814 38.521)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_241",
                "data-name": "Group 241",
                transform: "translate(142.382 358.933)",
                opacity: "0.36",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2-2",
                        "data-name": "Path 2",
                        d: "M84.833,74.579H41.841a13,13,0,0,1-12.813-11.11l-6.07-38.155a6.631,6.631,0,0,0-6.531-5.71,3.177,3.177,0,0,1,0-6.354A13,13,0,0,1,29.24,24.364l6.07,38.155a6.631,6.631,0,0,0,6.531,5.705H84.833a6.543,6.543,0,0,0,6.434-5.155l5.214-19.133a2.611,2.611,0,0,0-.563-2.139A2.7,2.7,0,0,0,93.8,40.782H50.312a3.177,3.177,0,0,1,0-6.354H93.8a9.066,9.066,0,0,1,8.848,11.034L97.434,64.591A12.82,12.82,0,0,1,84.833,74.579Z",
                        transform: "translate(-13.25 -13.25)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3-2",
                        "data-name": "Path 3",
                        d: "M29.9,52.546A11.648,11.648,0,1,1,41.546,40.9,11.658,11.658,0,0,1,29.9,52.546Zm0-16.943A5.295,5.295,0,1,0,35.193,40.9,5.3,5.3,0,0,0,29.9,35.6Z",
                        transform: "translate(2.929 38.521)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_4-2",
                        "data-name": "Path 4",
                        d: "M37.9,52.546A11.648,11.648,0,1,1,49.546,40.9,11.658,11.658,0,0,1,37.9,52.546Zm0-16.943A5.295,5.295,0,1,0,43.193,40.9,5.3,5.3,0,0,0,37.9,35.6Z",
                        transform: "translate(28.814 38.521)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "Group_240",
                "data-name": "Group 240",
                transform: "translate(183.382 358.933)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_2-3",
                        "data-name": "Path 2",
                        d: "M84.833,74.579H41.841a13,13,0,0,1-12.813-11.11l-6.07-38.155a6.631,6.631,0,0,0-6.531-5.71,3.177,3.177,0,0,1,0-6.354A13,13,0,0,1,29.24,24.364l6.07,38.155a6.631,6.631,0,0,0,6.531,5.705H84.833a6.543,6.543,0,0,0,6.434-5.155l5.214-19.133a2.611,2.611,0,0,0-.563-2.139A2.7,2.7,0,0,0,93.8,40.782H50.312a3.177,3.177,0,0,1,0-6.354H93.8a9.066,9.066,0,0,1,8.848,11.034L97.434,64.591A12.82,12.82,0,0,1,84.833,74.579Z",
                        transform: "translate(-13.25 -13.25)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_3-3",
                        "data-name": "Path 3",
                        d: "M29.9,52.546A11.648,11.648,0,1,1,41.546,40.9,11.658,11.658,0,0,1,29.9,52.546Zm0-16.943A5.295,5.295,0,1,0,35.193,40.9,5.3,5.3,0,0,0,29.9,35.6Z",
                        transform: "translate(2.929 38.521)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Path_4-3",
                        "data-name": "Path 4",
                        d: "M37.9,52.546A11.648,11.648,0,1,1,49.546,40.9,11.658,11.658,0,0,1,37.9,52.546Zm0-16.943A5.295,5.295,0,1,0,43.193,40.9,5.3,5.3,0,0,0,37.9,35.6Z",
                        transform: "translate(28.814 38.521)"
                    })
                ]
            })
        ]
    })
});

// EXTERNAL MODULE: ./components/Header/Navbar/styles.js
var styles = __webpack_require__(4240);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var dist_esm = __webpack_require__(5260);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./components/Cart/index.js
function Cart_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Cart_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Cart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Cart_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Cart_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Cart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Cart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Cart_slicedToArray(arr, i) {
    return Cart_arrayWithHoles(arr) || Cart_iterableToArrayLimit(arr, i) || Cart_unsupportedIterableToArray(arr, i) || Cart_nonIterableRest();
}
function Cart_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Cart_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Cart_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Cart_arrayLikeToArray(o, minLen);
}

function Cart_templateObject() {
    var data = Cart_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0.5rem;\n  bottom: 3rem;\n  width: 100%;\n  justify-content: center;\n  padding-right: 4rem;\n  background: white;\n"
    ]);
    Cart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Cart_templateObject1() {
    var data = Cart_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-bottom: 2rem;\n"
    ]);
    Cart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





























var getCartImage = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(mainImage, sku, variableUid, lang) {
        var image, res, data, filteredItem;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    image = {
                        label: mainImage === null || mainImage === void 0 ? void 0 : mainImage.label
                    };
                    _ctx.next = 3;
                    return axios_default().get("https://do.baltbaby.com/graphql?query=query%20GetProduct(%24sku%3A%20String!)%20%7B%0A%20%20products(filter%3A%20%7Bsku%3A%20%7Beq%3A%20%24sku%7D%7D)%20%7B%0A%20%20%20%20items%20%7B%0A%20%20%20%20%20%20...%20on%20ConfigurableProduct%20%7B%0A%20%20%20%20%20%20%20%20variants%20%7B%0A%20%20%20%20%20%20%20%20%20%20product%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20uid%0A%20%20%20%20%20%20%20%20%20%20%20%20image%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20url%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20__typename%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20__typename%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20__typename%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20__typename%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20__typename%0A%20%20%20%20%7D%0A%20%20%20%20__typename%0A%20%20%7D%0A%7D&operationName=GetProduct&variables=%7B%22sku%22%3A%22".concat(sku, "%22%7D"), {
                        headers: {
                            store: lang
                        }
                    });
                case 3:
                    res = _ctx.sent;
                    data = res.data.data;
                    if (data && data.products) {
                        if (data.products.items.length > 0) {
                            filteredItem = data.products.items[0].variants.filter(function(el) {
                                return el.product.uid === variableUid;
                            });
                            if (filteredItem.length > 0) {
                                image = Cart_objectSpread({}, image, {
                                    url: filteredItem[0].product.image.url
                                });
                            }
                        }
                    }
                    return _ctx.abrupt("return", image);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCartImage(mainImage, sku, variableUid, lang) {
        return _ref.apply(this, arguments);
    };
}();
function Cart(param) {
    var isHovered = param.isHovered;
    var ref8;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var lang = router.locale ? router.locale : "et";
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var cartRef = (0,react.useRef)(null);
    var ref1 = useCart(), cart = ref1.cart, open = ref1.open, setOpen = ref1.setOpen, updateItem = ref1.updateItem;
    var ref2 = (0,react.useState)(), cartWithImages = ref2[0], setCartWithImages = ref2[1];
    (0,react.useEffect)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, ref9, ref7, sku, mainImage, variableUid, image, updatedCart, singleItemIndex;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!((cart === null || cart === void 0 ? void 0 : cart.items.length) > 0)) {
                        _ctx.next = 34;
                        break;
                    }
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _ctx.prev = 2;
                    _iterator = cart.items[Symbol.iterator]();
                case 4:
                    if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                        _ctx.next = 20;
                        break;
                    }
                    item = _step.value;
                    ;
                    ref7 = item === null || item === void 0 ? void 0 : item.product, sku = ref7.sku, mainImage = ref7.image;
                    variableUid = item === null || item === void 0 ? void 0 : (ref9 = item.configured_variant) === null || ref9 === void 0 ? void 0 : ref9.uid;
                    if (!variableUid) {
                        _ctx.next = 17;
                        break;
                    }
                    _ctx.next = 12;
                    return getCartImage(mainImage, sku, variableUid, lang);
                case 12:
                    image = _ctx.sent;
                    updatedCart = cart;
                    singleItemIndex = cart.items.findIndex(function(el) {
                        var ref;
                        return ((ref = el.configured_variant) === null || ref === void 0 ? void 0 : ref.uid) === variableUid;
                    });
                    updatedCart.items[singleItemIndex].configured_variant["image"] = image;
                    setCartWithImages(updatedCart);
                case 17:
                    _iteratorNormalCompletion = true;
                    _ctx.next = 4;
                    break;
                case 20:
                    _ctx.next = 26;
                    break;
                case 22:
                    _ctx.prev = 22;
                    _ctx.t0 = _ctx["catch"](2);
                    _didIteratorError = true;
                    _iteratorError = _ctx.t0;
                case 26:
                    _ctx.prev = 26;
                    _ctx.prev = 27;
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                case 29:
                    _ctx.prev = 29;
                    if (!_didIteratorError) {
                        _ctx.next = 32;
                        break;
                    }
                    throw _iteratorError;
                case 32:
                    return _ctx.finish(29);
                case 33:
                    return _ctx.finish(26);
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                22,
                26,
                34
            ],
            [
                27,
                ,
                29,
                33
            ]
        ]);
    })), [
        cart
    ]);
    var itemsInCart = (cart === null || cart === void 0 ? void 0 : cart.items.length) > 0;
    var totalCharge = cart === null || cart === void 0 ? void 0 : cart.prices.grand_total.value;
    var discount = cart === null || cart === void 0 ? void 0 : cart.prices.discounts;
    var ref3 = Cart_slicedToArray((0,esm/* useAtom */.KO)(store/* authAtom */.L4), 1), ref4 = ref3[0], isAuth = ref4.token;
    var ref5 = Cart_slicedToArray((0,esm/* useAtom */.KO)(store/* accountFlyoutAtom */.vj), 2), isAccountFlyoutOpen = ref5[0], setAccountFlyoutOpen = ref5[1];
    var ref6 = Cart_slicedToArray((0,esm/* useAtom */.KO)(store/* authModalAtom */.C0), 2), authModalOpen = ref6[0], setAuthModalOpen = ref6[1];
    var toggleAccountButton = function() {
        setOpen(false);
        setTimeout(function() {
            if (isAuth) {
                setAccountFlyoutOpen(!isAccountFlyoutOpen);
            } else {
                setAuthModalOpen(!authModalOpen);
            }
        }, 1000);
    };
    var goToCheckout = function() {
        setOpen(false);
        router.push("/checkout");
    };
    (0,useClickOutside/* default */.Z)(cartRef, function() {
        return setOpen(false);
    }, viewportWidth >= 1024 && !isHovered);
    (0,useLockBodyScroll/* default */.Z)(open && viewportWidth < 1024 || authModalOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartContainer, {
        ref: cartRef,
        open: open,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* MobileNav */.zM, {
                mt: 22,
                mb: 18,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dismiss/* default */.Z, {
                        transform: "translateY(-20%)",
                        "aria-label": "Close shopping cart",
                        onClick: function() {
                            return setOpen(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* LogoLink */.vw, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                        align: "flex-end",
                        spaceX: "1rem",
                        mt: "0.6rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* AccountButton */.sE, {
                                onClick: toggleAccountButton
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* CartButton */.WE, {
                                quantity: cart === null || cart === void 0 ? void 0 : cart.total_quantity,
                                onClick: function() {
                                    return setOpen(false);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                display: {
                    _: "none",
                    desktop: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DismissSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dismiss/* default */.Z, {
                            "aria-label": "Close shopping cart",
                            onClick: function() {
                                return setOpen(false);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                            as: "span",
                            role: "button",
                            cursor: "pointer",
                            onClick: function() {
                                return setOpen(false);
                            },
                            fontSize: "large",
                            p: {
                                _: "0 0 2rem",
                                desktop: "0 2rem 0.5rem"
                            },
                            children: t("cart.shopping_cart")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* FlexBox */.h, {
                justify: itemsInCart ? "flex-start" : "center"
            }),
            !itemsInCart ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                dir: "column",
                align: "center",
                justify: "space-around",
                h: "100vh",
                pb: main/* isIOS */.gn ? "8rem" : "4rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        spaceY: "2rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                                as: "span",
                                position: "relative",
                                right: 12,
                                role: "img",
                                "aria-label": "Empty cart",
                                children: EmptyCart
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("cart.cart_empty")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContinueShopping, {
                        onClick: function() {
                            return setOpen(false);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Products, {
                        cart: cartWithImages,
                        updateItem: updateItem
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FixedContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceInfo, {
                                children: [
                                    discount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                children: [
                                                    t("cart.discount"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                children: (0,getFormattedPrice/* default */.Z)((ref8 = discount[0]) === null || ref8 === void 0 ? void 0 : ref8.amount.value)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                children: [
                                                    t("cart.total_sum"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "cartTotal",
                                                children: (0,getFormattedPrice/* default */.Z)(totalCharge)
                                            })
                                        ]
                                    }),
                                    totalCharge < 100 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                children: [
                                                    t("cart.until_free_delivery"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                className: "untilFreeDelivery",
                                                children: (0,getFormattedPrice/* default */.Z)(100 - totalCharge)
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                                children: [
                                                    t("cart.free_delivery"),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                role: "img",
                                                "aria-label": "Checkmark",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Checkmark */.MC, {
                                                    stroke: theme.colors["teal-300"],
                                                    width: "3"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !cart.applied_coupons ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponCode/* default */.Z, {
                                cartOpen: open
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                dir: "column",
                                align: "center",
                                position: "relative",
                                w: "100%",
                                pt: "0.5rem",
                                pl: {
                                    _: "1.5rem",
                                    lg_tablet: "0"
                                },
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                                        w: {
                                            _: "100%",
                                            lg_tablet: "65%"
                                        },
                                        p: "0.6rem 3rem",
                                        mb: "0.6rem",
                                        onClick: goToCheckout,
                                        children: t("cart.go_to_checkout")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContinueShopping, {
                                        onClick: function() {
                                            return setOpen(false);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var ContinueShopping = function(param) {
    var onClick = param.onClick;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Monochrome/* default */.Z, {
        w: {
            _: "100%",
            lg_tablet: "65%"
        },
        p: "0.6rem 2rem",
        onClick: onClick,
        children: t("cart.continue_shopping")
    });
};
var FixedContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3092493-0"
})(Cart_templateObject());
var DismissSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b3092493-1"
})(Cart_templateObject1());

// EXTERNAL MODULE: ./components/Header/LanguageSelector.js + 1 modules
var LanguageSelector = __webpack_require__(8285);
// EXTERNAL MODULE: ./global/data.js + 2 modules
var data = __webpack_require__(6863);
;// CONCATENATED MODULE: ./hooks/auth/useLogout.js






function useLogout(toggleMenu) {
    var router = (0,next_router.useRouter)();
    var cookies = new es6/* default */.Z();
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var desktop = viewportWidth >= 1024;
    var setAuth = (0,esm/* useSetAtom */.b9)(store/* authAtom */.L4);
    var setFlyoutOpen = (0,esm/* useSetAtom */.b9)(store/* accountFlyoutAtom */.vj);
    var toggle = function() {
        return desktop ? toggleMenu() : setFlyoutOpen(false);
    };
    var logout = function() {
        cookies.remove(constants/* USER_TOKEN */.G$, {
            path: "/"
        });
        cookies.remove(constants/* USER_SOCIAL_AUTH */.ZC, {
            path: "/"
        });
        cookies.remove(constants/* CART_ID */.je, {
            path: "/"
        });
        cookies.remove(constants/* AUTH_CART_INIT */.BA, {
            path: "/"
        });
        setAuth({
            token: null
        });
        toggle();
        router.push("/");
    };
    return logout;
};

// EXTERNAL MODULE: ./components/UI/Icons/Account/index.js
var Account = __webpack_require__(3848);
// EXTERNAL MODULE: ./utils/builders.js
var builders = __webpack_require__(7505);
;// CONCATENATED MODULE: ./components/Header/Menus/AccountMenu.js
function AccountMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function AccountMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AccountMenu_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function AccountMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AccountMenu_slicedToArray(arr, i) {
    return AccountMenu_arrayWithHoles(arr) || AccountMenu_iterableToArrayLimit(arr, i) || AccountMenu_unsupportedIterableToArray(arr, i) || AccountMenu_nonIterableRest();
}
function AccountMenu_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AccountMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return AccountMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return AccountMenu_arrayLikeToArray(o, minLen);
}
function AccountMenu_templateObject() {
    var data = AccountMenu_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  padding: 4rem 0 0 1rem;\n  z-index: 4;\n\n  @media (min-width: desktop) {\n    width: 208px;\n    min-height: 242px;\n    padding: 2.5rem 1.5rem;\n    position: absolute;\n    right: 70;\n    top: 50;\n    border-radius: 15px;\n    box-shadow: 0px 0px 12px 2px rgba(196, 196, 196, 1);\n  }\n\n  button {\n    padding: 0;\n    display: flex;\n\n    @media (max-width: desktop) {\n      align-items: center;\n    }\n\n    &:hover,\n    &:active {\n      color: teal-400;\n    }\n\n    &:last-of-type {\n      @media (max-width: desktop) {\n        padding-top: 2rem;\n      }\n    }\n\n    span {\n      margin-right: 1rem;\n\n      svg {\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n"
    ]);
    AccountMenu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var Options = styled_components_esm/* default.sectionBox */.ZPm.sectionBox(AccountMenu_templateObject());
var AccountMenu = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var toggleMenu = param.toggleMenu;
    var router = (0,next_router.useRouter)();
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var lang = router.locale ? router.locale : "et";
    var setOpen = (0,esm/* useSetAtom */.b9)(store/* accountFlyoutAtom */.vj);
    var logout = useLogout(toggleMenu);
    var navigate = function(path) {
        setOpen(false);
        router.push(path);
    };
    var _$ref = AccountMenu_slicedToArray((0,esm/* useAtom */.KO)(store/* customerAtom */.TM), 1), customer = _$ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Options, {
        ref: ref,
        spaceY: {
            _: "2rem",
            desktop: "1.25rem"
        },
        children: [
            data/* accountItems.map */.tk.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    onClick: function() {
                        return navigate(item.path);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            role: "img",
                            "aria-label": "Avatar",
                            children: item.icon
                        }),
                        t("my"),
                        " ",
                        lang === "en" ? item.titleEN : item.title
                    ]
                }, item.path);
            }),
            builders/* builders.includes */.Q.includes(customer === null || customer === void 0 ? void 0 : customer.email) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                onClick: function() {
                    return navigate("/builder");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "img",
                        "aria-label": "Exit sign",
                        children: Account/* Rebuild */.Zk
                    }),
                    "Rebuild"
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                onClick: logout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "img",
                        "aria-label": "Exit sign",
                        children: Account/* LogOut */.d6
                    }),
                    t("header.logout")
                ]
            })
        ]
    });
});
AccountMenu.displayName = "AccountMenu";
/* harmony default export */ var Menus_AccountMenu = (AccountMenu);

;// CONCATENATED MODULE: ./components/Header/Menus/AccountFlyout.js
function AccountFlyout_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AccountFlyout_templateObject() {
    var data = AccountFlyout_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100vw;\n  min-height: 100vh;\n  padding: 3rem 2rem;\n  background-color: white;\n  overflow-x: hidden;\n  z-index: 11;\n  animation: 0.5s in-out forwards;\n\n  @keyframes in-out {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  #account_return {\n    transform: scale(0.7);\n    margin: auto;\n  }\n"
    ]);
    AccountFlyout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var FlyoutContainer = styled_components_esm/* default.aside */.ZPm.aside(AccountFlyout_templateObject());
function MobileFlyout() {
    var setOpen = (0,esm/* useSetAtom */.b9)(store/* accountFlyoutAtom */.vj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlyoutContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dismiss/* default */.Z, {
                        "aria-label": "Close account menu",
                        onClick: function() {
                            return setOpen(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        id: "account_return",
                        role: "button",
                        "aria-label": "Go to homepage",
                        onClick: function() {
                            return setOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* Logo */.TR, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menus_AccountMenu, {})
        ]
    });
};

// EXTERNAL MODULE: ./components/Search/SearchBar.js + 3 modules
var SearchBar = __webpack_require__(8314);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./lib/Google/events/login.gtag.js
function loginEvent() {
    return gtag("event", "login");
};

;// CONCATENATED MODULE: ./hooks/auth/useLogin.js
function useLogin_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useLogin_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useLogin_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useLogin_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useLogin_slicedToArray(arr, i) {
    return useLogin_arrayWithHoles(arr) || useLogin_iterableToArrayLimit(arr, i) || useLogin_unsupportedIterableToArray(arr, i) || useLogin_nonIterableRest();
}
function useLogin_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useLogin_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useLogin_arrayLikeToArray(o, minLen);
}









function useLogin(param) {
    var toggleModal = param.toggleModal, setError = param.setError;
    var setAuth = (0,esm/* useSetAtom */.b9)(store/* authAtom */.L4);
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var setManualError = function(field) {
        return setError(field, {
            type: "manual",
            message: t("ui.check_data")
        });
    };
    var ref = useLogin_slicedToArray((0,useMutation/* useMutation */.D)(mutations/* GENERATE_TOKEN */.e6, {
        onCompleted: function(data) {
            loginEvent(); // Send login event to Google Analytics
            var token = data.generateCustomerToken.token;
            var cookies = new es6/* default */.Z();
            var expires = dayjs_min_default()().add(1, "d").toDate();
            cookies.set(constants/* USER_TOKEN */.G$, token, {
                path: "/",
                expires: expires
            });
            setAuth({
                token: token
            });
            toggleModal();
        },
        onError: function(error) {
            if (error.message.includes("sign-in was incorrect")) {
                setManualError("email");
                setManualError("password");
            }
        }
    }), 2), generateToken = ref[0], ref1 = ref[1], loading = ref1.loading, error1 = ref1.error;
    var onLoginSubmit = function(data) {
        generateToken({
            variables: {
                email: data.email,
                password: data.password
            }
        });
    };
    return {
        onLoginSubmit: onLoginSubmit,
        loading: loading && !error1
    };
};

// EXTERNAL MODULE: ./hooks/auth/usePasswordErrors.js
var usePasswordErrors = __webpack_require__(5047);
;// CONCATENATED MODULE: ./lib/Google/events/signup.gtag.js
function signupEvent() {
    return gtag("event", "sign_up");
};

;// CONCATENATED MODULE: ./hooks/auth/useSignup.js
function useSignup_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useSignup_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useSignup_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useSignup_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useSignup_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useSignup_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useSignup_slicedToArray(arr, i) {
    return useSignup_arrayWithHoles(arr) || useSignup_iterableToArrayLimit(arr, i) || useSignup_unsupportedIterableToArray(arr, i) || useSignup_nonIterableRest();
}
function useSignup_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useSignup_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useSignup_arrayLikeToArray(o, minLen);
}











function useSignup(param) {
    var toggleModal = param.toggleModal, fields = param.fields, setError = param.setError, clearErrors = param.clearErrors;
    var setAuth = (0,esm/* useSetAtom */.b9)(store/* authAtom */.L4);
    var ref = useSignup_slicedToArray((0,useMutation/* useMutation */.D)(mutations/* UPDATE_CUSTOMER */.Wn), 1), updateCustomer = ref[0];
    var ref1 = useSignup_slicedToArray((0,useMutation/* useMutation */.D)(mutations/* CREATE_CUSTOMER */._4, {
        onCompleted: function() {
            signupEvent(); // Send signup event to Google Analytics
            generateToken({
                variables: {
                    email: fields === null || fields === void 0 ? void 0 : fields.email,
                    password: fields === null || fields === void 0 ? void 0 : fields.password
                }
            });
        }
    }), 2), createCustomer = ref1[0], ref2 = ref1[1], signupLoading = ref2.loading, error = ref2.error;
    var ref3 = useSignup_slicedToArray((0,useMutation/* useMutation */.D)(mutations/* GENERATE_TOKEN */.e6, {
        onCompleted: function() {
            var _ref = useSignup_asyncToGenerator(runtime_default().mark(function _callee(data) {
                var token, cookies, expires;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            token = data.generateCustomerToken.token;
                            cookies = new es6/* default */.Z();
                            expires = dayjs_min_default()().add(1, "d").toDate();
                            cookies.set(constants/* USER_TOKEN */.G$, token, {
                                path: "/",
                                expires: expires
                            });
                            _ctx.next = 6;
                            return updateCustomer({
                                variables: {
                                    input: {
                                        allow_remote_shopping_assistance: true
                                    }
                                }
                            });
                        case 6:
                            // Set token in global state
                            setAuth({
                                token: token
                            });
                            // Toggle modal
                            toggleModal();
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }()
    }), 2), generateToken = ref3[0], ref4 = ref3[1], loginLoading = ref4.loading;
    var onSignupSubmit = function(data) {
        return createCustomer({
            variables: data
        });
    };
    var setPasswordMismatchError = function(field) {
        return setError(field, {
            type: "manual",
            message: "Paroolid ei kattu"
        });
    };
    var clearPasswordErrors = function() {
        clearErrors("password");
        clearErrors("repeatPassword");
    };
    // Set password errors manually
    (0,usePasswordErrors/* default */.Z)(error, setError);
    // Check if password and repeated password match
    (0,react.useEffect)(function() {
        if ((fields === null || fields === void 0 ? void 0 : fields.password) && (fields === null || fields === void 0 ? void 0 : fields.repeatPassword)) {
            if ((fields === null || fields === void 0 ? void 0 : fields.password) !== (fields === null || fields === void 0 ? void 0 : fields.repeatPassword)) {
                setPasswordMismatchError("password");
                setPasswordMismatchError("repeatPassword");
            } else {
                clearPasswordErrors();
            }
        } else {
            clearPasswordErrors();
        }
    }, [
        fields === null || fields === void 0 ? void 0 : fields.password,
        fields === null || fields === void 0 ? void 0 : fields.repeatPassword
    ]);
    // Validate e-mail, if already in use (error from Magento)
    (0,react.useEffect)(function() {
        if (error && error.message.includes("already exists")) {
            setError("email", {
                type: "manual",
                message: "Sellise e-mailiga kasutaja juba eksisteerib"
            });
        } else {
            clearErrors("email");
        }
    }, [
        error
    ]);
    return {
        onSignupSubmit: onSignupSubmit,
        loading: signupLoading || loginLoading
    };
};

;// CONCATENATED MODULE: ./hooks/auth/useSocialMediaAuth.js





function useSocialMediaAuth(toggle) {
    var ref = (0,react.useState)(null), popup = ref[0], setPopup = ref[1];
    var openPopup = function(provider) {
        setPopup(window.open("".concat(constants/* CLIENT */.ID, "/api/auth/").concat(provider), "Baltbaby ".concat(provider, " login"), "scrollbars=no,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=800,height=700"));
    };
    var closePopup = function() {
        popup.close();
        setPopup(null);
    };
    var setAuth = (0,esm/* useSetAtom */.b9)(store/* authAtom */.L4);
    (0,react.useEffect)(function() {
        var interval;
        var cookies = new es6/* default */.Z();
        if (popup) {
            interval = setInterval(function() {
                var token = cookies.get(constants/* USER_TOKEN */.G$);
                if (token) {
                    setAuth({
                        token: token
                    });
                    closePopup();
                    toggle();
                }
            }, 1000);
        }
        return function() {
            return clearInterval(interval);
        };
    }, [
        popup
    ]);
    return openPopup;
};

;// CONCATENATED MODULE: ./components/UI/Button/SocialMedia.js





function SocialMediaButton(param) {
    var name = param.name, onClick = param.onClick;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        w: {
            _: 230,
            mobile: 260,
            tablet: 300
        },
        py: 8,
        spaceX: 16,
        margin: "0 auto",
        whiteSpace: "nowrap",
        bg: name === "Facebook" ? "#A8D5FD" : "#EC7272",
        hoverBg: name === "Facebook" ? "#79BFFD" : "#EE5656",
        color: "white",
        fontWeight: "500",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                as: "span",
                role: "img",
                "aria-label": "".concat(name, " logo"),
                position: "relative",
                top: 2,
                children: name === "Facebook" ? Icons/* FacebookLight */.Pf : Icons/* Google */.ie
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    t("ui.enter"),
                    " ",
                    name,
                    " ",
                    t("ui.with_account")
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Modal/index.js
var Modal = __webpack_require__(9968);
// EXTERNAL MODULE: ./components/UI/Form/Input.js
var Input = __webpack_require__(2979);
// EXTERNAL MODULE: ./components/UI/Loader/Spinner.js
var Spinner = __webpack_require__(7162);
;// CONCATENATED MODULE: ./components/Modals/Auth.js
function Auth_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Auth_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Auth_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Auth_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Auth_templateObject() {
    var data = Auth_taggedTemplateLiteral([
        "\n  flex-direction: column;\n\n  @media (max-width: 375px) {\n    width: 90%;\n\n    button span {\n      font-size: xxsmall;\n    }\n  }\n"
    ]);
    Auth_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




















function AuthModal(param) {
    var isShown = param.isShown, toggle = param.toggle;
    var t = (0,dist_esm/* useTranslation */.$G)().t;
    var ref = (0,index_esm/* useForm */.cI)(), register = ref.register, watch = ref.watch, handleSubmit = ref.handleSubmit, reset = ref.reset, errors = ref.formState.errors, setError = ref.setError, clearErrors = ref.clearErrors;
    var fields = watch();
    var ref1 = (0,react.useState)("login"), authType = ref1[0], setAuthType = ref1[1];
    var isLogin = authType === "login";
    var setTogglePasswordReset = (0,esm/* useSetAtom */.b9)(store/* resetPasswordModalAtom */.Gn);
    // Login
    var ref2 = useLogin({
        toggleModal: toggle,
        setError: setError
    }), onLoginSubmit = ref2.onLoginSubmit, loginLoading = ref2.loading;
    // Signup
    var ref3 = useSignup({
        toggleModal: toggle,
        fields: fields,
        setError: setError,
        clearErrors: clearErrors
    }), onSignupSubmit = ref3.onSignupSubmit, signupLoading = ref3.loading;
    (0,react.useEffect)(function() {
        if (isShown) {
            setAuthType("login");
            reset();
        }
    }, [
        isShown,
        reset
    ]);
    var modalContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexColCenter */.S, {
        as: "form",
        onSubmit: handleSubmit(isLogin ? onLoginSubmit : onSignupSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings/* SectionTitle */.NZ, {
                pb: "3rem",
                children: isLogin ? t("auth.login") : t("auth.create_account")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaButtons, {
                toggle: toggle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                dir: "column",
                w: "80%",
                py: "3rem",
                spaceY: "1.5rem",
                children: [
                    !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Auth_objectSpread({
                                placeholder: t("forms_data.firstname")
                            }, register("firstname", {
                                required: "Kohustuslik v\xe4li"
                            }), {
                                error: errors.firstname
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Auth_objectSpread({
                                placeholder: t("forms_data.lastname")
                            }, register("lastname", {
                                required: "Kohustuslik v\xe4li"
                            }), {
                                error: errors.lastname
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Auth_objectSpread({
                        type: "email",
                        placeholder: t("forms_data.email")
                    }, register("email", {
                        required: t("checkout.required")
                    }), {
                        error: errors.email
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
                        pt: !isLogin && "1rem",
                        spaceY: "1.5rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Auth_objectSpread({
                                type: "password",
                                placeholder: t("forms_data.password")
                            }, register("password", {
                                required: t("checkout.required")
                            }), {
                                error: errors.password
                            })),
                            !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, Auth_objectSpread({
                                type: "password",
                                placeholder: t("forms_data.repeat_password")
                            }, register("repeatPassword", {
                                required: t("checkout.required")
                            }), {
                                error: errors.repeatPassword
                            }))
                        ]
                    })
                ]
            }),
            isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                dir: "column",
                w: "80%",
                spaceY: "0.5rem",
                pb: "3rem",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                        type: "submit",
                        h: "3rem",
                        children: loginLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : t("auth.login")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        hoverTextDecoration: "underline",
                        onClick: function() {
                            toggle();
                            setTogglePasswordReset(true);
                        },
                        children: t("auth.forgot_password")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                type: "submit",
                w: "80%",
                h: "2.5rem",
                children: signupLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : "Registreeru"
            }),
            !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                color: "black",
                fontWeight: "600",
                textDecoration: "underline",
                hoverColor: "gray-100",
                onClick: function() {
                    return setAuthType(isLogin ? "signup" : "login");
                },
                children: isLogin ? t("auth.register_new_user") : t("auth.already_registered_login_here")
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
        isShown: isShown,
        hide: toggle,
        content: modalContent,
        width: {
            _: "90vw",
            sm_tablet: "500px",
            tablet: "590px"
        },
        p: {
            _: "3rem 1rem",
            desktop: "3rem 4rem"
        },
        h: {
            _: !isLogin && (main/* isIOS */.gn ? "80vh" : "88vh"),
            desktop: "100%"
        }
    });
};
var Buttons = (0,styled_components_esm/* default */.ZPm)(FlexBox/* FlexBox */.h)(Auth_templateObject());
var SocialMediaButtons = function(param) {
    var toggle = param.toggle;
    var openPopup = useSocialMediaAuth(toggle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Buttons, {
        spaceY: "0.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaButton, {
                name: "Facebook",
                onClick: function() {
                    return openPopup("facebook");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialMediaButton, {
                name: "Google",
                onClick: function() {
                    return openPopup("google");
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Modals/ResetPassword.js
var ResetPassword = __webpack_require__(8866);
// EXTERNAL MODULE: ./components/UI/Layout/Container.js
var Container = __webpack_require__(6094);
;// CONCATENATED MODULE: ./components/Header/Navbar/index.js
function Navbar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Navbar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Navbar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Navbar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Navbar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Navbar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Navbar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Navbar_slicedToArray(arr, i) {
    return Navbar_arrayWithHoles(arr) || Navbar_iterableToArrayLimit(arr, i) || Navbar_unsupportedIterableToArray(arr, i) || Navbar_nonIterableRest();
}
function Navbar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Navbar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Navbar_arrayLikeToArray(o, minLen);
}

















// import { CompareLarge } from '@/UI/Button/Compare';




function Navbar() {
    var router = (0,next_router.useRouter)();
    var cart = (0,useCartData/* default */.Z)();
    var ref = Navbar_slicedToArray((0,esm/* useAtom */.KO)(store/* authAtom */.L4), 1), ref1 = ref[0], isAuth = ref1.token;
    var ref2 = Navbar_slicedToArray((0,esm/* useAtom */.KO)(store/* cartSidebarAtom */.zj), 2), isCartOpen = ref2[0], setCartOpen = ref2[1];
    var ref3 = Navbar_slicedToArray((0,esm/* useAtom */.KO)(store/* authModalAtom */.C0), 2), authModalOpen = ref3[0], setAuthModalOpen = ref3[1];
    var ref4 = Navbar_slicedToArray((0,esm/* useAtom */.KO)(store/* accountFlyoutAtom */.vj), 2), isAccountFlyoutOpen = ref4[0], setAccountFlyoutOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isAccountDropdownOpen = ref5[0], setAccountDropdownOpen = ref5[1];
    var ref6 = Navbar_slicedToArray(useHover(), 2), isHovered = ref6[0], bind = ref6[1];
    var toggleCart = function() {
        return setCartOpen(!isCartOpen);
    };
    var accountMenuRef = (0,react.useRef)(null);
    (0,useClickOutside/* default */.Z)(accountMenuRef, function() {
        return setAccountDropdownOpen(false);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_esm/* Box */.xuv, {
        as: "nav",
        h: "88px",
        m: {
            desktop: "2.125rem 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* MobileNav */.zM, {
                children: [
                    !router.pathname.endsWith("search") ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* HamburgerButton */.rQ, {
                        "aria-label": "Open navigation menu",
                        onClick: function() {
                            return router.push("/menu");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "button",
                        "aria-label": "Close shopping cart",
                        onClick: toggleCart,
                        children: Icons/* HorizontalChevron */.n_
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* LogoLink */.vw, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                        align: "flex-end",
                        spaceX: "1rem",
                        mt: "0.6rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* AccountButton */.sE, {
                                onClick: isAuth ? function() {
                                    return setAccountFlyoutOpen(!isAccountFlyoutOpen);
                                } : function() {
                                    return setAuthModalOpen(!authModalOpen);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* CartButton */.WE, {
                                quantity: cart === null || cart === void 0 ? void 0 : cart.total_quantity,
                                onClick: toggleCart
                            })
                        ]
                    })
                ]
            }),
            isAccountFlyoutOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFlyout, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                display: {
                    _: "none",
                    desktop: "block"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* LogoLink */.vw, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                        align: "center",
                                        spaceX: "1rem",
                                        ml: "4rem",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* AccountButton */.sE, {
                                                isActive: isAccountDropdownOpen,
                                                onClick: isAuth ? function() {
                                                    return setAccountDropdownOpen(!isAccountDropdownOpen);
                                                } : function() {
                                                    return setAuthModalOpen(!authModalOpen);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, Navbar_objectSpread({}, bind, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Links/* CartButton */.WE, {
                                                    quantity: cart === null || cart === void 0 ? void 0 : cart.total_quantity,
                                                    isActive: isCartOpen,
                                                    onClick: toggleCart
                                                })
                                            }))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isAccountDropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menus_AccountMenu, {
                        ref: accountMenuRef,
                        toggleMenu: function() {
                            return setAccountDropdownOpen(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cart, {
                isHovered: isHovered
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal, {
                isShown: authModalOpen,
                toggle: function() {
                    return setAuthModalOpen(!authModalOpen);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPassword/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 4240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JH": function() { return /* binding */ IconLink; },
/* harmony export */   "lz": function() { return /* binding */ ProductsInCart; },
/* harmony export */   "rQ": function() { return /* binding */ HamburgerButton; },
/* harmony export */   "zM": function() { return /* binding */ MobileNav; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7248);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  @media (min-width: desktop) {\n    display: none;\n  }\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  a {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n\n    @media (max-width: 400px) {\n      transform: translateX(-60%);\n    }\n\n    @media (max-width: 350px) {\n      transform: translateX(-65%);\n    }\n\n    span {\n      position: relative;\n\n      svg {\n        transform: scale(0.7);\n\n        @media (max-width: 330px) {\n          transform: scale(0.5);\n        }\n      }\n    }\n  }\n\n  span[role='button'] > svg {\n    position: relative;\n    top: 0.25rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: xxsmall;\n  color: ",
        ";\n  cursor: pointer;\n  white-space: nowrap;\n\n  @media (max-width: desktop) {\n    font-size: 0.625rem;\n  }\n\n  #avatar {\n    stroke: ",
        ";\n  }\n\n  #cart {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    color: ",
        ";\n\n    #avatar {\n      stroke: ",
        ";\n    }\n\n    #cart {\n      fill: ",
        ";\n    }\n  }\n\n  span {\n    display: flex;\n    align-items: center;\n    font-size: xxsmall;\n\n    @media (max-width: desktop) {\n      font-size: 0.625rem;\n    }\n\n    svg {\n      transform: scale(1.2);\n      margin: 0 0 0.25rem 0.2rem;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 1.2rem;\n  right: 0.3rem;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  background-color: pink-100;\n  color: white;\n  font-size: xxsmall;\n  border-radius: 50%;\n\n  @media (max-width: desktop) {\n    bottom: 0.9rem;\n    right: 0;\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  height: 22px;\n  background-color: white;\n  border: none;\n  padding: 0;\n  margin-top: -0.4rem;\n  z-index: 1;\n  -webkit-user-select: none;\n  user-select: none;\n  cursor: pointer;\n\n  span {\n    position: relative;\n    display: block;\n    height: 3px;\n    margin-bottom: 5px;\n    border-radius: 3px;\n    background-color: teal-300;\n    z-index: 1;\n\n    &:nth-of-type(1) {\n      width: 29px;\n    }\n\n    &:nth-of-type(2) {\n      width: 24px;\n    }\n\n    &:nth-of-type(3) {\n      width: 12px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var activeColor = "teal-400";
var setActiveColor = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .ivY)(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive && _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__.th.color("".concat(activeColor));
});
var MobileNav = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject1());
var IconLink = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].spanBox */ .ZPm.spanBox(_templateObject2(), setActiveColor, setActiveColor, setActiveColor, activeColor, activeColor, activeColor);
var ProductsInCart = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span */ .ZPm.span(_templateObject3());
var HamburgerButton = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button */ .ZPm.button(_templateObject4());


/***/ }),

/***/ 8314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(1641);
// EXTERNAL MODULE: ./graphql/queries/index.js + 28 modules
var queries = __webpack_require__(4462);
;// CONCATENATED MODULE: ./utils/getSearchTerm.js
function getSearchTerm(term) {
    return term === null || term === void 0 ? void 0 : term.replace(/[^a-zA-Z0-9]/g, " ");
};

// EXTERNAL MODULE: ./hooks/UI/useClickOutside.js
var useClickOutside = __webpack_require__(5167);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/getProductPrice.js
var getProductPrice = __webpack_require__(5689);
// EXTERNAL MODULE: ./components/UI/ProductCard/DiscountPercentBadge.js
var DiscountPercentBadge = __webpack_require__(4522);
// EXTERNAL MODULE: ./components/UI/utils.js
var utils = __webpack_require__(1040);
// EXTERNAL MODULE: ./components/UI/Primitives/FlexBox.js
var FlexBox = __webpack_require__(5653);
// EXTERNAL MODULE: ./utils/getProductImage.js
var getProductImage = __webpack_require__(7883);
;// CONCATENATED MODULE: ./components/Search/Results.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  align-items: start;\n  grid-template-columns: 80px 200px 1fr;\n  padding-top: 0.5rem;\n  border-bottom: 1px solid #e3e9ec;\n\n  p {\n    padding: 0.75rem 0.5rem 0 1rem;\n    font-weight: 500;\n    line-height: 1.2;\n  }\n\n  .newPrice {\n    padding: 0.5rem 1rem 0 0;\n    font-weight: 500;\n    font-size: small;\n    color: teal-200;\n    white-space: nowrap;\n  }\n\n  .originalPrice {\n    padding: 0;\n    position: relative;\n    color: blue-200;\n\n    &:after {\n      ",
        ";\n    }\n  }\n\n  &:hover p {\n    color: gray-100;\n  }\n\n  @media (max-width: 454.98px) {\n    grid-template-columns: 1fr 160px 1fr;\n\n    p,\n    .newPrice,\n    .originalPrice {\n      font-size: xxsmall;\n    }\n\n    .newPrice {\n      padding: 0.65rem 1rem 0 0;\n    }\n  }\n\n  @media (min-width: 455px) and (max-width: desktop) {\n    grid-template-columns: 100px 1fr 1fr;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ResultRow = styled_components_esm/* default.divBox */.ZPm.divBox(_templateObject(), utils/* CrossOut */.B4);
function SearchQueryResults(_param) {
    var searchResults = _param.searchResults, slice = _param.slice, imageSize = _param.imageSize, setShowDropdown = _param.setShowDropdown, showDiscountBadge = _param.showDiscountBadge, rest = _objectWithoutProperties(_param, [
        "searchResults",
        "slice",
        "imageSize",
        "setShowDropdown",
        "showDiscountBadge"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: searchResults === null || searchResults === void 0 ? void 0 : searchResults.slice(0, slice).map(function(result) {
            var ref;
            var ref1 = (0,getProductPrice/* default */.Z)(result === null || result === void 0 ? void 0 : result.price_range), priceValue = ref1.priceValue, discount = ref1.discount;
            var image = (0,getProductImage/* default */.Z)({
                mainImage: result === null || result === void 0 ? void 0 : result.image,
                gallery: result === null || result === void 0 ? void 0 : result.media_gallery
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/toode/".concat(result === null || result === void 0 ? void 0 : result.url_key),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return setShowDropdown(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultRow, _objectSpread({}, rest, {
                        children: [
                            (discount === null || discount === void 0 ? void 0 : discount.percentNumber) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountPercentBadge/* default */.Z, {
                                percent: "-" + Math.round(Number(discount === null || discount === void 0 ? void 0 : (ref = discount.percent) === null || ref === void 0 ? void 0 : ref.replace("-", "").replace(" ", "").replace("kuni", "").replace("%", ""))) + "%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image === null || image === void 0 ? void 0 : image.url,
                                alt: image === null || image === void 0 ? void 0 : image.label,
                                width: imageSize.width,
                                height: imageSize.height,
                                layout: "fixed",
                                objectFit: "contain"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: result === null || result === void 0 ? void 0 : result.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* FlexBox */.h, {
                                spaceX: 8,
                                flexWrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "newPrice",
                                        children: priceValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "originalPrice",
                                        children: discount === null || discount === void 0 ? void 0 : discount.value
                                    })
                                ]
                            })
                        ]
                    }))
                })
            }, result === null || result === void 0 ? void 0 : result.url_key);
        })
    });
};

// EXTERNAL MODULE: ./components/UI/Loader/index.js
var Loader = __webpack_require__(1395);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/Search/Dropdown.js
function Dropdown_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Dropdown_templateObject() {
    var data = Dropdown_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  padding: 1rem;\n  background-color: white;\n  box-shadow: 0px 0px 17px -1px rgba(227, 233, 236, 0.42);\n  border-radius: 15px;\n  z-index: 12;\n\n  a:last-child {\n    padding-top: 1rem;\n    font-weight: 500;\n    text-decoration: underline;\n\n    &:hover {\n      color: teal-200;\n    }\n  }\n"
    ]);
    Dropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var SearchResults = styled_components_esm/* default.div */.ZPm.div(Dropdown_templateObject());
function Dropdown(param) {
    var searchTerm = param.searchTerm, searchResults = param.searchResults, setShowDropdown = param.setShowDropdown, loading = param.loading;
    var t = (0,esm/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResults, {
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                mt: -12
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchQueryResults, {
                searchResults: searchResults,
                imageSize: {
                    width: 80,
                    height: 100
                },
                slice: 5,
                setShowDropdown: setShowDropdown
            }),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/otsing/[term]",
                as: "/otsing/".concat(searchTerm),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: t("search.all_results")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/UI/Primitives/ClientOnly.js
var ClientOnly = __webpack_require__(1028);
// EXTERNAL MODULE: ./components/UI/Icons/Header/index.js
var Header = __webpack_require__(378);
;// CONCATENATED MODULE: ./components/Search/SearchBar.js
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  width: 81vw;\n  border: none;\n  border-bottom: 2px solid #a8a9ba;\n  background-color: transparent;\n  cursor: pointer;\n  caret-color: #d0d0d0;\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  ::placeholder {\n    font-size: xxsmall;\n    text-align: center;\n  }\n\n  @media (min-width: 455px) {\n    width: 400px;\n  }\n\n  @media (min-width: desktop) {\n    height: 30px;\n    margin-top: -2rem;\n  }\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  position: relative;\n\n  span svg {\n    position: absolute;\n    right: 4;\n  }\n\n  @media (min-width: desktop) {\n    margin-left: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var SearchInput = styled_components_esm/* default.inputBox */.ZPm.inputBox(SearchBar_templateObject());
var SearchBarWrapper = (0,styled_components_esm/* default */.ZPm)(ClientOnly/* default */.Z)(_templateObject1());
function SearchBar(param) {
    var isSearchPage = param.isSearchPage;
    var ref6;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var lang = router.locale ? router.locale : "et";
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react.useState)(true), showDropdown = ref2[0], setShowDropdown = ref2[1];
    var ref3 = (0,react.useState)(null), searchResults = ref3[0], setSearchResults = ref3[1];
    var handleFocus = function() {
        return searchResults && !isSearchPage && setShowDropdown(true);
    };
    var handleChange = function(event) {
        return setSearchTerm(event.target.value);
    };
    var handleEnter = function(event) {
        return searchTerm && event.charCode === 13 && router.push("/otsing/".concat(searchTerm));
    };
    var ref4 = (0,useQuery/* useQuery */.a)(queries/* SEARCHED_PRODUCTS */.g4, {
        skip: searchTerm.length < 4,
        variables: {
            name: getSearchTerm(searchTerm),
            pageSize: 5,
            currentPage: 1
        },
        context: {
            fetchOptions: {
                method: "GET"
            },
            headers: {
                store: lang
            }
        }
    }), data = ref4.data, loading = ref4.loading;
    var searchRef = (0,react.useRef)(null);
    (0,useClickOutside/* default */.Z)(searchRef, function() {
        return setShowDropdown(false);
    });
    (0,react.useEffect)(function() {
        if ((searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) || loading) {
            if (isSearchPage) {
                setShowDropdown(false);
            } else {
                setShowDropdown(true);
            }
        } else {
            setShowDropdown(false);
        }
    }, [
        searchResults,
        loading,
        isSearchPage
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.items) {
            var ref5;
            setSearchResults(data === null || data === void 0 ? void 0 : (ref5 = data.products) === null || ref5 === void 0 ? void 0 : ref5.items);
        }
        if (searchTerm.length < 4) {
            setSearchResults(null);
        }
    }, [
        data === null || data === void 0 ? void 0 : (ref6 = data.products) === null || ref6 === void 0 ? void 0 : ref6.items,
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
        ref: searchRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                    type: "text",
                    name: "searchTerm",
                    value: searchTerm,
                    placeholder: t("search.bar_placeholder"),
                    onChange: handleChange,
                    onFocus: handleFocus,
                    onKeyPress: handleEnter
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_esm/* Box */.xuv, {
                    as: "span",
                    role: "button",
                    "aria-label": "Magnifying glass representing search",
                    cursor: "pointer",
                    onClick: function() {
                        return searchTerm && router.push("/otsing/".concat(searchTerm));
                    },
                    children: Header/* Search */.ol
                }),
                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                    searchTerm: searchTerm,
                    searchResults: searchResults,
                    setShowDropdown: setShowDropdown,
                    loading: loading
                })
            ]
        })
    });
};


/***/ }),

/***/ 7013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MonochromeButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8356);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


/**
 * MonochromeButton
 *
 * The monochrome button component
 *
 * @prop {ReactNode | ReactNodeArray} children - button content
 */ function MonochromeButton(_param) {
    var children = _param.children, rest = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
        bg: "transparent",
        border: "1px solid black",
        hoverBorder: "1px solid gray",
        color: "black",
        hoverColor: "gray-100"
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 2519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponCode; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@xstyled/styled-components/dist/styled-components.esm.js
var styled_components_esm = __webpack_require__(4337);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(4931);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./graphql/mutations/index.js + 30 modules
var mutations = __webpack_require__(9592);
// EXTERNAL MODULE: ./hooks/cart/useCartId.js
var useCartId = __webpack_require__(3580);
// EXTERNAL MODULE: ./node_modules/@xstyled/core/dist/core.esm.js
var core_esm = __webpack_require__(1278);
;// CONCATENATED MODULE: ./hooks/cart/useCouponCode.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function useCouponCode(cartOpen) {
    var viewportWidth = (0,core_esm/* useViewportWidth */.jK)();
    var ref4 = (0,react.useState)(false), isOpen1 = ref4[0], setIsOpen = ref4[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var cartId = (0,useCartId/* default */.Z)();
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, watch = ref2.watch, reset = ref2.reset;
    var code = watch("code");
    var ref3 = _slicedToArray((0,useMutation/* useMutation */.D)(mutations/* APPLY_COUPON */.QL, {
        variables: {
            cartId: cartId,
            code: code
        },
        onError: setError,
        onCompleted: function() {
            react_hot_toast_esm/* default.success */.ZP.success("Soodustus rakendatud", {
                style: {
                    position: "relative",
                    top: viewportWidth >= 1024 ? "-30px" : 0
                }
            });
        }
    }), 2), applyCoupon = ref3[0], loading = ref3[1].loading;
    var toggle = function() {
        return setIsOpen(function(isOpen) {
            return !isOpen;
        });
    };
    var resetForm = function() {
        reset();
        setError(null);
    };
    (0,react.useEffect)(function() {
        var errorMessage = function(text) {
            var ref;
            return error === null || error === void 0 ? void 0 : (ref = error.message) === null || ref === void 0 ? void 0 : ref.includes(text);
        };
        if (!isOpen1) resetForm();
        if (cartOpen === false) {
            resetForm();
            setIsOpen(false);
        }
        if (error) {
            if (errorMessage("isn't valid")) {
                setError({
                    message: "Kood ei kehti"
                });
            }
            if (errorMessage("not provided") || errorMessage("missing")) {
                setError({
                    message: "Sisesta kood"
                });
            }
        }
    }, [
        isOpen1,
        cartOpen,
        error
    ]);
    return {
        isOpen: isOpen1,
        toggle: toggle,
        applyCoupon: applyCoupon,
        loading: loading,
        register: register,
        error: error
    };
};

// EXTERNAL MODULE: ./components/UI/Form/Input.js
var Input = __webpack_require__(2979);
// EXTERNAL MODULE: ./components/UI/Button/index.js
var Button = __webpack_require__(8356);
// EXTERNAL MODULE: ./components/UI/Button/Variants/Primary.js
var Primary = __webpack_require__(6803);
// EXTERNAL MODULE: ./components/UI/Icons/index.js
var Icons = __webpack_require__(9430);
// EXTERNAL MODULE: ./components/UI/Loader/Spinner.js
var Spinner = __webpack_require__(7162);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 68 modules
var esm = __webpack_require__(5260);
;// CONCATENATED MODULE: ./components/UI/CouponCode/index.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 250px;\n  height: 80px;\n  margin-top: 1rem;\n\n  button span {\n    position: relative;\n    left: 2.5rem;\n    bottom: 0.1rem;\n\n    svg {\n      transform: ",
        ";\n      transition: transform 0.3s ease-out;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  width: 320px;\n  margin-top: 1rem;\n\n  input {\n    width: 90%;\n    height: 40px;\n    padding: 12px 0;\n    border: 0.8px solid #a8a9ba;\n    border-radius: 7px;\n  }\n\n  @media (max-width: sm_mobile) {\n    width: 280px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var CodeWrapper = styled_components_esm/* default.div */.ZPm.div(_templateObject(), function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "rotate(180deg)" : "rotate(0)";
});
var CodeForm = styled_components_esm/* default.form */.ZPm.form(_templateObject1());
/**
 * CouponCode
 *
 * Coupon code form
 *
 * @prop {boolean} cartOpen - is cart in open state?
 */ function CouponCode(param) {
    var cartOpen = param.cartOpen;
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,styled_components_esm/* useTheme */.FgM)();
    var ref = useCouponCode(cartOpen), isOpen = ref.isOpen, toggle = ref.toggle, applyCoupon = ref.applyCoupon, loading = ref.loading, register = ref.register, error = ref.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CodeWrapper, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                onClick: toggle,
                children: [
                    "% ",
                    t("ui.discount_code"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "img",
                        "aria-label": "Toggle promo code form",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* VerticalChevron */.Cx, {
                            stroke: theme.colors["purple-200"]
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CodeForm, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, _objectSpread({}, register("code"), {
                        error: error
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Primary/* default */.Z, {
                        p: "0.5rem 2rem",
                        ml: "1rem",
                        onClick: function() {
                            return applyCoupon();
                        },
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : t("ui.apply")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dismiss; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
/* harmony import */ var _UI_Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9430);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function Dismiss(_param) {
    var onClick = _param.onClick, ariaLabel = _param.ariaLabel, rest = _objectWithoutProperties(_param, [
        "onClick",
        "ariaLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, _objectSpread({
        as: "span",
        role: "button",
        cursor: "pointer",
        "aria-label": ariaLabel,
        onClick: onClick
    }, rest, {
        children: _UI_Icons__WEBPACK_IMPORTED_MODULE_1__/* .HorizontalChevron */ .n_
    }));
};


/***/ }),

/***/ 6094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n\n  @media (min-width: desktop) {\n    max-width: 980px;\n  }\n\n  @media (min-width: lg_desktop) {\n    max-width: 1140px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Container = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].divBox */ .ZPm.divBox(_templateObject());


/***/ }),

/***/ 1395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_content_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4561);
/* harmony import */ var _Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5653);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var ThreeDots = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_content_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        viewBox: "0 0 400 120",
        height: 120,
        width: 400,
        foregroundColor: "#000",
        backgroundColor: "transparent",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "150",
                cy: "86",
                r: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "194",
                cy: "86",
                r: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "238",
                cy: "86",
                r: "4"
            })
        ]
    });
};
function Loader(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_1__/* .FlexBox */ .h, _objectSpread({
        justify: "center"
    }, rest, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ThreeDots, {})
    }));
};


/***/ }),

/***/ 9647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Spacer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


/**
 * Spacer
 *
 * A generic component to render space between other components
 *
 * @prop {string} spaceY - prop to override space below
 * @prop {string} spaceX - prop to override space to the right
 */ function Spacer(param) {
    var spaceY = param.spaceY, spaceX = param.spaceX;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        as: "span",
        display: "block",
        mb: spaceY || "2rem",
        mr: spaceX || 0
    });
};


/***/ }),

/***/ 4522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DiscountPercentBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


function DiscountPercentBadge(param) {
    var percent = param.percent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        position: "absolute",
        top: {
            _: 10,
            desktop: 20
        },
        left: {
            _: 10,
            desktop: 20
        },
        p: 8,
        lineHeight: 1.1,
        textAlign: "center",
        color: "white",
        bg: "#f65a84",
        borderRadius: 3,
        zIndex: 2,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
            as: "span",
            display: "inline-block",
            maxW: {
                _: 54,
                desktop: 64
            },
            children: percent
        })
    });
};


/***/ }),

/***/ 5167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useClickOutside(ref, handler) {
    var when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var handlerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(handler);
    var handleClickOutside = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (ref && ref.current && !ref.current.contains(event.target)) {
            handlerRef.current(event);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        handlerRef.current = handler;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (when) {
            document.addEventListener("click", handleClickOutside, true);
            document.addEventListener("ontouchstart", handleClickOutside, true);
            return function() {
                document.removeEventListener("click", handleClickOutside, true);
                document.removeEventListener("ontouchstart", handleClickOutside, true);
            };
        }
    }, [
        ref,
        handler,
        when
    ]);
};


/***/ }),

/***/ 7310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCartData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1131);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1641);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(561);
/* harmony import */ var graphql_queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4462);
/* harmony import */ var _useCartId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3580);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







function useCartData() {
    var id = (0,_useCartId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var lang = router.locale ? router.locale : "et";
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)(graphql_queries__WEBPACK_IMPORTED_MODULE_2__/* .CART */ .$L, {
        variables: {
            id: id
        },
        context: {
            fetchOptions: {
                method: "GET"
            },
            headers: {
                store: lang
            }
        },
        fetchPolicy: "network-only"
    }).data;
    var ref = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_1__/* .cartAtom */ .cY), 2), cart = ref[0], setCart = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.cart) setCart(data === null || data === void 0 ? void 0 : data.cart);
    }, [
        data === null || data === void 0 ? void 0 : data.cart
    ]);
    return cart;
};


/***/ }),

/***/ 3580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCartId; }
/* harmony export */ });
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5885);
/* harmony import */ var global_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(827);


function useCartId() {
    var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    var ref;
    return (ref = cookies.get(global_constants__WEBPACK_IMPORTED_MODULE_0__/* .CART_ID */ .je)) !== null && ref !== void 0 ? ref : null;
};


/***/ }),

/***/ 7505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ builders; }
/* harmony export */ });
var builders = [
    "marge@navin.ee",
    "sten.vallimae@gmail.com",
    "marisborn@gmail.com",
    "antsovvirko@gmail.com",
    "piret.roop@gmail.com",
    "vaherkata@gmail.com"
];


/***/ }),

/***/ 7496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getCartProductData; }
});

;// CONCATENATED MODULE: ./utils/getPrice.js
function getPrice(rangePrice, price) {
    var cost;
    if (rangePrice) {
        cost = {
            regularPrice: rangePrice === null || rangePrice === void 0 ? void 0 : rangePrice.regular_price.value,
            finalPrice: rangePrice === null || rangePrice === void 0 ? void 0 : rangePrice.final_price.value,
            discount: rangePrice === null || rangePrice === void 0 ? void 0 : rangePrice.discount.percent_off
        };
    } else {
        cost = price === null || price === void 0 ? void 0 : price.regularPrice.amount.value;
    }
    return cost;
};

// EXTERNAL MODULE: ./utils/getFormattedPrice.js
var getFormattedPrice = __webpack_require__(2425);
;// CONCATENATED MODULE: ./utils/getCartProductData.js


function getCartProductData(item1) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var priceWithTax = item1 === null || item1 === void 0 ? void 0 : (ref = item1.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.row_total_including_tax) === null || ref1 === void 0 ? void 0 : ref1.value;
    var altPrice = getPrice(item1 === null || item1 === void 0 ? void 0 : (ref2 = item1.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price_range) === null || ref3 === void 0 ? void 0 : ref3.minimum_price, item1 === null || item1 === void 0 ? void 0 : (ref4 = item1.product) === null || ref4 === void 0 ? void 0 : ref4.price);
    var ref6;
    var price = (0,getFormattedPrice/* default */.Z)((ref6 = priceWithTax !== null && priceWithTax !== void 0 ? priceWithTax : altPrice === null || altPrice === void 0 ? void 0 : altPrice.finalPrice) !== null && ref6 !== void 0 ? ref6 : altPrice);
    var selectedVariants = item1 === null || item1 === void 0 ? void 0 : (ref5 = item1.configurable_options) === null || ref5 === void 0 ? void 0 : ref5.map(function(item) {
        return item.value_label;
    });
    return {
        price: price,
        selectedVariants: selectedVariants
    };
};


/***/ }),

/***/ 2425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFormattedPrice; }
/* harmony export */ });
function getFormattedPrice(price) {
    return "".concat(price === null || price === void 0 ? void 0 : price.toFixed(2).toString().replace(/\./g, ","), " \u20AC");
};


/***/ }),

/***/ 7883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getProductImage; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getProductImage(param) {
    var mainImage = param.mainImage, gallery = param.gallery;
    var ref;
    var image = {
        label: mainImage === null || mainImage === void 0 ? void 0 : mainImage.label
    };
    if ((mainImage === null || mainImage === void 0 ? void 0 : (ref = mainImage.url) === null || ref === void 0 ? void 0 : ref.includes("placeholder")) && (gallery === null || gallery === void 0 ? void 0 : gallery.length)) {
        var ref1;
        image = _objectSpread({}, image, {
            url: (ref1 = gallery[0]) === null || ref1 === void 0 ? void 0 : ref1.url
        });
    } else {
        image = _objectSpread({}, image, {
            url: mainImage === null || mainImage === void 0 ? void 0 : mainImage.url
        });
    }
    return image;
};


/***/ }),

/***/ 5689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getProductPrice; }
/* harmony export */ });
/* harmony import */ var _getFormattedPrice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2425);

function getProductPrice(prices) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var minimum = prices === null || prices === void 0 ? void 0 : prices.minimum_price;
    var minimumFinalValue = minimum === null || minimum === void 0 ? void 0 : (ref = minimum.final_price) === null || ref === void 0 ? void 0 : ref.value;
    var minimumRegularValue = minimum === null || minimum === void 0 ? void 0 : (ref1 = minimum.regular_price) === null || ref1 === void 0 ? void 0 : ref1.value;
    var maximum = prices === null || prices === void 0 ? void 0 : prices.maximum_price;
    var maximumFinalValue = maximum === null || maximum === void 0 ? void 0 : (ref2 = maximum.final_price) === null || ref2 === void 0 ? void 0 : ref2.value;
    var maximumRegularValue = maximum === null || maximum === void 0 ? void 0 : (ref3 = maximum.regular_price) === null || ref3 === void 0 ? void 0 : ref3.value;
    var priceRange = minimumFinalValue !== maximumFinalValue;
    var minimumPrice = (0,_getFormattedPrice__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(minimumFinalValue);
    var maximumPrice = (0,_getFormattedPrice__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(maximumFinalValue);
    var priceValue = priceRange ? "al. ".concat(minimumPrice) : maximumPrice;
    var discount = priceRange ? (minimum === null || minimum === void 0 ? void 0 : (ref4 = minimum.discount) === null || ref4 === void 0 ? void 0 : ref4.amount_off) > 0 ? {
        value: "al. ".concat((0,_getFormattedPrice__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(minimumRegularValue)),
        percent: "kuni -".concat((ref5 = minimum.discount) === null || ref5 === void 0 ? void 0 : ref5.percent_off, "%"),
        percentNumber: maximum === null || maximum === void 0 ? void 0 : (ref6 = maximum.discount) === null || ref6 === void 0 ? void 0 : ref6.percent_off
    } : null : (maximum === null || maximum === void 0 ? void 0 : (ref7 = maximum.discount) === null || ref7 === void 0 ? void 0 : ref7.amount_off) > 0 ? {
        value: (0,_getFormattedPrice__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(maximumRegularValue),
        percent: "-".concat(maximum === null || maximum === void 0 ? void 0 : (ref8 = maximum.discount) === null || ref8 === void 0 ? void 0 : ref8.percent_off, "%"),
        percentNumber: maximum === null || maximum === void 0 ? void 0 : (ref9 = maximum.discount) === null || ref9 === void 0 ? void 0 : ref9.percent_off
    } : null;
    return {
        priceValue: priceValue,
        discount: discount
    };
};


/***/ })

}]);